export enum TransactionType {
    WALLET = 'deposit',
    CARD = 'card'
}
